import React, { useState, useEffect, useContext } from "react";
import { VegaFlex, VegaInputSelect, VegaInput } from "@heartlandone/vega-react";
import { HubContext } from "Redux/Context/context";

function ActivityFormCategory({ onChange, isEdit = false }) {
    const { activityCategoriesState } = useContext(HubContext);
    const [fieldValue, setFieldValue] = useState('');
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState();
  

  useEffect(() => {
    if(activityCategoriesState?.categories){
        setCategories(activityCategoriesState.categories.map((item) => ({
            id: item.categoryId.toString(),
            displayName: item.categoryName,
        })));
    }
    // eslint-disable-next-line
  }, [activityCategoriesState]);

  useEffect(() => {
    const category = categories.find(
      (category) => category.displayName === fieldValue
    );
    if (category) {
      setCategory(category.id);
      setFieldValue(category.displayName);
    }
    // eslint-disable-next-line
  }, [fieldValue, categories]);

  useEffect(() => {
    onChange(fieldValue);
    // eslint-disable-next-line
  }, [fieldValue]);

  const onValueChange = (e) => {
    if(e.detail){
        setFieldValue(e.detail);
    }
  };

  const onSelectChange = (e) => {
    if(e.detail){
        const category = categories.find(
            (category) => category.id === e.detail
        );
        if (category) {
            setCategory(category.id);
            setFieldValue(category.displayName);
        }
    }
  };
  return (
    <>
      <VegaInput
        data-vega-form="publisherCategory"
        value={fieldValue}
        onVegaChange={onValueChange}
        style={{ display: "none" }}
      />
      <VegaFlex direction="col" gap="size-24">
        {
        <VegaInputSelect
          size="small"
          gap="size-24"
          required={true}
          disabled={isEdit}
          source={categories}
          data-vega-form="publisherCategory-temp"
          value={category}
          label="Category"
          vegaDropdownProps={{
            searchable: false,
          }}
          onVegaChange={onSelectChange}
        />
        }
      </VegaFlex>
    </>
  );
}

export default ActivityFormCategory;
